<script setup lang="ts">
import type { TagFilter } from 'types';

const props = defineProps<{
  tagFilters?: TagFilter[];
  queryTag?: string;
}>();

defineOptions({
  inheritAttrs: false,
});

const emits = defineEmits(['tagFiltersChanged']);
const activeTag = ref<string>(props.queryTag || '');

const noTagPreselected = computed(() => {
  return !props.tagFilters?.some(tag => tag.selected === true);
});

const tagFiltersChanged = useDebounceFn((encodedValue: string) => {
  activeTag.value = encodedValue;
  emits('tagFiltersChanged', encodedValue);
}, 400);
</script>

<template>
  <aside v-if="tagFilters && tagFilters.length > 0">
    <ul
      class="mb-8 select-none gap-2"
      v-bind="$attrs"
    >
      <li class="flex">
        <label
          class="hover:safe-bold cursor-pointer py-2 pr-4 transition-colors duration-300"
          :class="{
            'safe-bold underline underline-offset-2': activeTag === '',
          }"
          for="all-tags"
          @click="tagFiltersChanged('')"
        >
          {{ $t('General.All') }}
        </label>

        <input
          id="all-tags"
          class="invisible h-0 w-0"
          :checked="noTagPreselected"
          type="radio"
          name="tag_filter"
        />
      </li>

      <li
        v-for="tagFilter in tagFilters"
        :key="tagFilter.encodedValue"
        class="flex"
      >
        <label
          class="hover:safe-bold cursor-pointer py-2 pr-4 transition-colors duration-300"
          :class="{
            'safe-bold underline underline-offset-2': activeTag === tagFilter.encodedValue,
          }"
          :for="tagFilter.encodedValue"
          @click="tagFiltersChanged(tagFilter.encodedValue)"
        >
          {{ tagFilter.displayValue }}
        </label>

        <input
          :id="tagFilter.encodedValue"
          class="invisible h-0 w-0"
          :checked="tagFilter.selected"
          type="radio"
          name="tag_filter"
        />
      </li>
    </ul>
  </aside>
</template>
